/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const GroupHeading = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.GroupHeading;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

GroupHeading.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      GroupHeading: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

GroupHeading.defaultProps = {
  selectProps: {
    custom: {
      GroupHeading: null,
    },
  },
  children: null,
};

export default GroupHeading;
